$('.logos').slick({
                      dots: false,
                      infinite: true,
                      speed: 800,
                      slidesToShow: 6,
                      adaptiveHeight: false,
                      arrows: false,
                      draggable: false,
                      autoplay: true,
                      autoplaySpeed: 4000,
                      responsive: [{
                          breakpoint: 992, settings: {
                              slidesToShow: 4
                          }
                      }]
                  });
